import { Box } from "@mui/system";
import React, { useState } from "react";
import { Link } from "react-router-dom";


import logo from "../../assets/ecomlovers-logo-transparente.svg";
import { ContentContainer } from "./ContentContainer";
import iconHeart from "../../assets/Vector (23).png";

import "./PublicLayout.css";

export const PublicLayout = ({ children, styles }) => {
  return (
    <Box className="boxPublicLayout">
      <div className="contentPublicLayoutWeb">
        <div className="headerPublicLayout">
          <Link to="/">
            <img src={logo} alt="" />
          </Link>
        </div>

        <ContentContainer>
          {children}
        </ContentContainer>

        <div className="footerPublicLayout">
          Desenvolvido com
          <img src={iconHeart} alt="" />
          <strong>© eComLovers®</strong>
        </div>
      </div>

    </Box>
  );
};
